import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Calendar, Clock, CheckCircle2 } from 'lucide-react';

const BookingPage = () => {
  const navigate = useNavigate();


  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'ViewContent', {
        content_name: 'Booking Page',
        content_category: 'Funnel'
      });
    }
  }, []);
// fohfsdf
  const benefits = [
    "Personalized LinkedIn growth strategy",
    "Custom content plan for your industry",
    "ROI projections for your business",
    "Q&A about our guarantee"
  ];

  return (
    <div className="booking-page">
      <div className="booking-page-glow"></div>

      <div className="container">
        <div className="booking-page-content">
          {/* Back Button */}
          <button onClick={() => navigate('/video')} className="back-button">
            ← Back to Video
          </button>

          {/* Header */}
          <div className="booking-page-header">
            <h1 className="booking-page-title">
              Book Your <span className="gradient-text">Free Consultation</span>
            </h1>
            <p className="booking-page-subtitle">
              Let's discuss how we can grow your LinkedIn presence and generate consistent leads
            </p>
          </div>

          <div className="booking-grid">
            {/* Left Side - Benefits */}
            <div className="booking-info">
              <Card className="booking-info-card">
                <h2 className="booking-info-title">What to Expect on the Call:</h2>
                <div className="booking-benefits-list">
                  {benefits.map((benefit, index) => (
                    <div key={index} className="booking-benefit-item">
                      <CheckCircle2 className="w-5 h-5 booking-benefit-icon" />
                      <span>{benefit}</span>
                    </div>
                  ))}
                </div>

                <div className="booking-details">
                  <div className="booking-detail-item">
                    <Clock className="w-5 h-5" />
                    <span>30-minute strategy session</span>
                  </div>
                  <div className="booking-detail-item">
                    <Calendar className="w-5 h-5" />
                    <span>Choose a time that works for you</span>
                  </div>
                </div>

                <div className="booking-guarantee">
                  <div className="guarantee-badge">
                    <CheckCircle2 className="w-6 h-6" />
                  </div>
                  <div>
                    <div className="guarantee-title">Our Guarantee</div>
                    <div className="guarantee-text">
                      3000 followers & 15-30 leads in 180 days or we work for FREE
                    </div>
                  </div>
                </div>
              </Card>
            </div>

            {/* Right Side - TidyCal Widget */}
            <div className="booking-calendar">
              <Card className="booking-calendar-card">
                <iframe
                  src="https://tidycal.com/dudigamashivakumar/linkedin-discovery-call?embed=1"
                  width="100%"
                  height="700"
                  frameBorder="0"
                  title="TidyCal Booking"
                  style={{ minHeight: '700px', overflow: 'hidden' }}
                ></iframe>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingPage;